import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NavService } from '../../../_services/_nav.service';
import { CampaniaDctoCiclos } from '../../../_models/campania-dcto-ciclos';
import { Campania } from '../../../_models/campania';
import { CampaniaDctoCicloService } from '../../../_services/campania-dcto-ciclo.service';
import { Funcionalidad } from '../../../_models/funcionalidad';
import { AutenticacionService } from '../../../_services/autenticacion.service';
import { ModalidadTasa } from '../../../_models/modalidad-tasa';
import { Table } from 'primeng/table';
import { Location } from '@angular/common';

@Component( {
  selector: 'app-campanias-dcto-ciclos-detalle',
  templateUrl: 'campanias-dcto-ciclos-detalle.component.html'
} )

export class CampaniasDctoCiclosDetalleComponent implements OnInit {

  @Input() campania: Campania;

  campaniaDctoCiclos: CampaniaDctoCiclos;
  carTabla = true;
  // Lista de campañas descuentos ciclos
  lisCampaniasDctoCiclos: CampaniaDctoCiclos [] = [];
  carInformacionInicial = false;
  formulario: FormGroup;
  columnas: any[];
  @ViewChild('dt') tabla: Table;

  constructor( private autServicio: AutenticacionService,
               private camDctoCicloServicio: CampaniaDctoCicloService,
               private conServicio: ConfirmationService,
               private nav: NavService,
               private confirmationService: ConfirmationService,
               private fb: FormBuilder,
               private location: Location) {

  }

  ngOnInit(): void {

    // Definiendo columnas datatable
    this.columnas = [
      { field: 'numeroCiclo', header: this.nav.buscarMensaje( 'CAMPANIADCTOCICLO.LBL_NUMEROCICLO' ), sort: false },
      { field: 'descuentoTasa', header: this.nav.buscarMensaje( 'CAMPANIADCTOCICLO.LBL_DESCUENTOTASA' ), sort: false },
    ];
    // Inicializando formulario
    this.carServicio();
    this.cargarTabla();
  }

  carServicio() {
    this.formulario = this.fb.group( {
      idCampaniaDctoCiclo: [this.campaniaDctoCiclos ? this.campaniaDctoCiclos.idCampaniaDctoCiclo : null],
      idCampania: [this.campania ? this.campania.idCampania : null, [Validators.required]],
      numeroCiclo: [this.campaniaDctoCiclos ? this.campaniaDctoCiclos.numeroCiclo : null, [Validators.required]],
      descuentoTasa: [this.campaniaDctoCiclos ? this.campaniaDctoCiclos.descuentoTasa : null, [Validators.required]],
      indicadorSuma: [this.campaniaDctoCiclos ? this.campaniaDctoCiclos.indicadorSuma : false, [Validators.required]],
      indicadorHabilitado: [this.campaniaDctoCiclos ? this.campaniaDctoCiclos.indicadorHabilitado : true, [Validators.required]],
    } );
  }

  cargarTabla() {
    this.lisCampaniasDctoCiclos = [];
    this.camDctoCicloServicio.listadoCampaniasDctoCiclosIdCampania( this.campania.idCampania ).subscribe( res => {
      this.lisCampaniasDctoCiclos = res;
      this.carTabla = false;
    } );
  }

  obtenerCampanias() {
    return this.lisCampaniasDctoCiclos.filter( x => x.indicadorHabilitado );
  }

  regresar() {
    this.location.back();
  }

  get f() {
    return this.formulario.controls;
  }

}
